import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const AIDashboardPage = lazy(() =>
  import('../pages/ai-intelligence').then((m) => ({ default: m.AIDashboardPage }))
)
const ClassificationsPage = lazy(() =>
  import('../pages/ai-intelligence').then((m) => ({ default: m.ClassificationsPage }))
)
const PredictionsPage = lazy(() =>
  import('../pages/ai-intelligence').then((m) => ({ default: m.PredictionsPage }))
)
const DocumentAnalysisPage = lazy(() =>
  import('../pages/ai-intelligence').then((m) => ({ default: m.DocumentAnalysisPage }))
)
const DocumentIntelligencePage = lazy(() =>
  import('../pages/ai-intelligence').then((m) => ({ default: m.DocumentIntelligencePage }))
)
const AIIntelligenceSettingsPage = lazy(() =>
  import('../pages/ai-intelligence').then((m) => ({ default: m.AIIntelligenceSettingsPage }))
)

export const aiIntelligenceRoutes: RouteObject[] = [
  {
    path: '/ai-intelligence',
    children: [
      { index: true, element: <AIDashboardPage /> },
      { path: 'dashboard', element: <AIDashboardPage /> },
      { path: 'classifications', element: <ClassificationsPage /> },
      { path: 'predictions', element: <PredictionsPage /> },
      { path: 'document-analysis', element: <DocumentAnalysisPage /> },
      { path: 'doc-intelligence', element: <DocumentIntelligencePage /> },
      { path: 'settings', element: <AIIntelligenceSettingsPage /> },
    ],
  },
]
